import React from "react";

export interface IconProps extends React.SVGAttributes<HTMLOrSVGElement> {
  size?: number;
}

export const IconHoursAllocationSummary: React.FC<IconProps> = ({
  size = 20,
  ...rest
}) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 29 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        {/* Lista / checklist à esquerda */}
        <path
          d="M9 11.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm2-1a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1zm1 2a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3zm0 3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3zm-2-2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
          fill="#616161"
        />
        <path
          d="M9 2a1 1 0 0 0-1 1H6a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2a1 1 0 0 0-1-1H9zm7 3h2v15H6V5h2v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V5zm-6 0V4h4v1h-4z"
          fill="#616161"
        />

        {/* Relógio à direita */}
        <circle
          cx="22"
          cy="13"
          r="6"
          stroke="#9E9E9E"
          strokeWidth="2"
          fill="#F5F5F5"
        />
        <line
          x1="22"
          y1="13"
          x2="22"
          y2="9.5"
          stroke="#616161"
          strokeWidth="1.5"
        />
        <line
          x1="22"
          y1="13"
          x2="24.5"
          y2="14.5"
          stroke="#616161"
          strokeWidth="1.5"
        />
      </svg>
    </>
  );
};
